module.exports = __webpack_public_path__ + "img/iphonemockup.a6bed098.png";